import { getConfig } from '../../config';
function nodeLogFn(...args) {
    const util = require('util'); // eslint-disable-line
    process.stdout.write(args.shift() + ' ');
    process.stdout.write(args
        .map((a) => {
        if (a instanceof FormData) {
            return 'FormData';
        }
        if (a instanceof Blob) {
            return 'Blob';
        }
        return typeof a === 'object' ? util.inspect(a, { colors: true, maxStringLength: 100 }) : a;
    })
        .join(' '));
    process.stdout.write('\n');
}
const noop = () => {
    // noop
};
export class Logger {
    constructor(tag) {
        this.tag = '';
        if (tag) {
            this.tag = `🐶 [${tag}]`;
        }
    }
    get log() {
        if (!shouldLog('log')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.log.bind(this, this.tag);
    }
    get warn() {
        if (!shouldLog('warn')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.warn.bind(console, this.tag);
    }
    get info() {
        if (!shouldLog('info')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.info.bind(console, this.tag);
    }
    get error() {
        if (!shouldLog('error')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.error.bind(console, this.tag);
    }
    get debug() {
        if (!shouldLog('debug')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.debug.bind(console, this.tag);
    }
    get trace() {
        if (!shouldLog('trace')) {
            return noop;
        }
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'test' ? nodeLogFn.bind(this, this.tag) : console.trace.bind(console, this.tag);
    }
}
const shouldLog = (logLevel) => {
    var _a;
    if ((_a = getConfig().LOG_LEVELS) === null || _a === void 0 ? void 0 : _a.includes(logLevel)) {
        return true;
    }
    return false;
};
